/* eslint-disable no-unused-expressions */
import { createSlice } from "@reduxjs/toolkit";
import {
  forgotPassword,
  login,
  resetPassword,
  signUp,
  verifyEmail,
  logout,
  verifyStoreUser,
  updateShopifyAppUser,
} from "../../api/auth";

const initialState = {
  isLoading: false,
  isSuccess: false,
  loggedUser: null,
  userQuestionnaires: [],
  profileImg: null,
  sideBarExpand: true,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    getAddUserData: (state, { payload }) => {
      state.userDataForAdd = payload;
    },
    getLoggedUser: (state, { payload }) => {
      state.loggedUser = payload;
    },
    getUserQuestionnaires: (state, { payload }) => {
      state.userQuestionnaires = payload;
    },
    getProfileImg: (state, { payload }) => {
      state.profileImg = payload;
    },
    logoutUser: () => {
      localStorage.clear();
      localStorage.removeItem("persist:root");
      window.location.href = "/";
    },
    setSidebarExpandStatus: (state, { payload }) => {
      state.sideBarExpand = payload;
    },
    updateLoggedUser: (state, action) => {
      const updatedStore = action.payload;

      console.log("updatedStore from slice", updatedStore)
      if (state.loggedUser) {
        const storeIndex = state.loggedUser.stores.findIndex(
          (store) => store._id.toString() === updatedStore?._id?.toString()
        );
        if (storeIndex !== -1) {
          state.loggedUser.stores[storeIndex] = updatedStore;
          state.loggedUser.user = {
            ...state.loggedUser.user,
            personalized_workspace: true
          };
        }
      }
    },
  },
  extraReducers: {
    [signUp.pending]: (state) => {
      state.isLoading = true;
    },
    [signUp.fulfilled]: (state) => {
      state.isLoading = false;
      return state;
    },
    [signUp.rejected]: (state) => {
      state.isLoading = false;
    },
    [verifyEmail.pending]: (state) => {
      state.isLoading = true;
    },
    [verifyEmail.fulfilled]: (state) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [verifyEmail.rejected]: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    [verifyStoreUser.pending]: (state) => {
      state.isLoading = true;
    },
    [verifyStoreUser.fulfilled]: (state, { payload }) => {
      state.isSuccess = true;
      state.isLoading = false;
      state.loggedUser = payload;
    },
    [verifyStoreUser.rejected]: (state) => {
      state.isLoading = false;
    },
    [login.pending]: (state) => {
      state.isLoading = true;
    },
    [login.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.loggedUser = payload;
    },
    [login.rejected]: (state) => {
      state.isLoading = false;
    },
    [updateShopifyAppUser.pending]: (state) => {
      state.isLoading = true;
    },
    [updateShopifyAppUser.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.loggedUser = payload;
    },
    [updateShopifyAppUser.rejected]: (state) => {
      state.isLoading = false;
    },
    [forgotPassword.pending]: (state) => {
      state.isLoading = true;
    },
    [forgotPassword.fulfilled]: (state) => {
      state.isLoading = false;
    },
    [forgotPassword.rejected]: (state) => {
      state.isLoading = false;
    },
    [resetPassword.pending]: (state) => {
      state.isLoading = true;
    },
    [resetPassword.fulfilled]: (state) => {
      state.isSuccess = true;
      state.isLoading = false;
    },
    [resetPassword.rejected]: (state) => {
      state.isLoading = false;
    },

    [logout.pending]: (state) => {
      state.isLoading = true;
    },
    [logout.fulfilled]: (state) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [logout.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const {
  getAddUserData,
  getLoggedUser,
  logoutUser,
  getUserQuestionnaires,
  getProfileImg,
  setSidebarExpandStatus,
  updateLoggedUser
} = authSlice.actions;
export const authSelector = (state) => state.auth;
export default authSlice.reducer;
